import React from "react"
import { Col, Container, Row } from "react-bootstrap"
import { FaCar } from "react-icons/fa";
import { IoCar, IoCarSport } from "react-icons/io5";

export function AutoPartsBar(props) {
    const { national, imported } = props.data;
    const cs = props.cs.autoParts;
    return (
        <Container className="pt-4">
            <Row className='p-4 auto-parts-bar'>
                {national.new &&
                    <Col>
                        <Row>
                            <Col xs={12} sm={4} md={4} lg={4} xl={4} xxl={4} className="border bg-theme-ternary d-flex align-items-center justify-content-center">
                                <FaCar size={60} />
                            </Col>
                            <Col className="d-flex align-items-center justify-content-center">
                                <small>
                                    {cs.national} {national.new.isNew}<br />
                                    <span>{cs.priceFrom} {national.new.minimalPrice}</span>
                                </small>
                            </Col>
                        </Row>
                    </Col>
                }
                {national.old &&
                    <Col>
                        <Row>
                            <Col xs={12} sm={4} md={4} lg={4} xl={4} xxl={4} className="border bg-theme-ternary d-flex align-items-center justify-content-center">
                                <IoCar size={60} />
                            </Col>
                            <Col className="d-flex align-items-center justify-content-center">
                                <small>
                                    {cs.national} {national.old.isNew}-<br />
                                    <span>{cs.priceFrom} {national.old.minimalPrice}</span>
                                </small>
                            </Col>
                        </Row>
                    </Col>
                }
                {imported &&
                    <Col>
                        <Row>
                            <Col xs={12} sm={4} md={4} lg={4} xl={4} xxl={4} className="border bg-theme-ternary d-flex align-items-center justify-content-center">
                                <IoCarSport size={60} />
                            </Col>
                            <Col className="d-flex align-items-center justify-content-center">
                                <small>
                                    {cs.imported}<br />
                                    <span>{cs.priceFrom} {imported.minimalPrice}</span>
                                </small>
                            </Col>
                        </Row>
                    </Col>
                }
            </Row>
        </Container>
    )
}